<template>
    <div
        class="popover-container"
        v-show="active"
        @mouseenter="inside = true"
        @mouseleave="inside = false"
        :style="style"
    >
        <component :is="contentComponent" :value="value" v-if="contentComponent" />
    </div>
</template>
<script>
import CompanyPopover from './company-popover.vue'
import ExecutivePopover from './executive-popover.vue'
import SearchResultPopover from './search-result-popover.vue'

export default {
    components: {
        executive: ExecutivePopover,
        company: CompanyPopover,
        'search-result': SearchResultPopover,
    },
    data() {
        return {
            inside: false,
            closed: new Date(),
            coordinates: {
                x: 0,
                y: 0,
            },
        }
    },
    watch: {
        target() {
            this.computeBestCoordinates()
        },
        open() {
            if (this.open) {
                const bounds = this.popover.content?.target?.getBoundingClientRect()
                if (
                    this.coordinates.x < bounds.left ||
                    this.coordinates.x > bounds.right ||
                    this.coordinates.y < bounds.top ||
                    this.coordinates.y > bounds.bottom ||
                    new Date() - this.closed > 500
                ) {
                    this.computeBestCoordinates()
                }
            } else {
                this.closed = new Date()
            }
        },
    },
    computed: {
        style() {
            return {
                left: `${this.coordinates.x + 1}px`,
                top: `${this.coordinates.y + 1}px`,
            }
        },
        contentComponent() {
            let component = this.type || ''
            if (this.$options.components[component]) {
                return component
            }
            return null
        },
        active() {
            return (this.open || this.inside) && this.contentComponent
        },
        popover() {
            return this.$store.getters.popover
        },
        type() {
            return this.popover.content?.type
        },
        value() {
            return this.popover.content?.value
        },
        open() {
            return this.popover.open
        },
        target() {
            return this.popover.content?.target
        },
    },
    methods: {
        computeBestCoordinates() {
            let x = this.popover.content?.clientX || 0
            let y = this.popover.content?.clientY || 0

            // we like it so it is to the right of the pointer, but if
            // we blast off the edge of the screen push it to the left
            if (x + 320 > window.innerWidth) {
                x -= 320
            }

            // also like it so it is to the bottom of the pointer, but if
            // we blast off the edge of the screen push it up
            if (y - window.scrollY + 136 > window.innerHeight) {
                y -= 136
            }

            this.coordinates = { x, y }
        },
    },
}
</script>
<style>
.popover-container {
    display: block;
    position: absolute;
    width: 320px;
    background-color: white;
    padding: 8px;
    box-shadow: var(--boxshadow-default);
    z-index: 1000;

    .header {
        display: flex;
        align-items: center;

        .details {
            flex-grow: 1;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .position {
            font-size: 12px;
            color: #666;
            margin-right: 8px;
            text-align: right;
            width: 88px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }

    .button-set {
        display: flex;
        justify-content: space-around;
        margin-bottom: 8px;
        margin-top: 32px;
        width: 100%;

        .button,
        button {
            width: 45%;
            text-transform: uppercase;
            padding: 0 8px !important;
        }
    }
    .btn-set:after {
        content: '';
        clear: both;
        display: table;
    }

    .watchlist-button .material-icons {
        display: none;
    }
}
</style>
